import { useMemo } from 'react';

import MAIN_LAYOUT_ROUTES from 'affiliates/routes/mainLayoutRoutes';
import SIMPLE_LAYOUT_ROUTES from 'affiliates/routes/simpleLayoutRoutes';
import { ErrorBoundaryRoot } from 'common/components/ErrorBoundary';
import Header from 'affiliates/components/Header';
import Sidebar from 'affiliates/components/Sidebar';
import { useT } from 'common/i18n';
import LayoutSwitcher from 'common/components/LayoutSwitcher';

const LayoutSwitcherWrapper = (props) => {
  const t = useT('sidebar');
  const mainLayoutRoutes = useMemo(
    () =>
      MAIN_LAYOUT_ROUTES.map((route) => ({
        ...route,
        pageConfig: {
          ...route.pageConfig,
          title: route.pageConfig?.title
            ? t(route.pageConfig.title, { showSkeleton: false })
            : null,
        },
      })),
    [t],
  );

  return (
    <ErrorBoundaryRoot>
      <LayoutSwitcher
        mainLayoutRoutes={mainLayoutRoutes}
        simpleLayoutRoutes={SIMPLE_LAYOUT_ROUTES}
        sidebar={<Sidebar routes={mainLayoutRoutes} />}
        header={<Header />}
        {...props}
      />
    </ErrorBoundaryRoot>
  );
};

export default [{ component: LayoutSwitcherWrapper, path: '*' }];
